//Componentes generales
import React, { useContext, useEffect, useReducer } from "react";
import productsReducer from "./productsReducer";
import productsContext from "./productsContext";

//Socket
import { SocketContext } from "../socket/socket";

//Rutas de api
import { getAbmProduct, uploadAbmProduct, uploadAbmProductIndividual } from "../../api/abmProduct.js"
import { getAbmAtributoProducto } from "../../api/abmAtributoProducto.js"

//Acciones
import {
    ACTUALIZAR_PRODUCTOS,
    ACTUALIZAR_PRODUCTOS_DB,
    ACTUALIZAR_PRODUCTOS_SOCKET,
    ACTUALIZAR_ATRIBUTOS,
    CARGANDO_PROD,
    ERROR_PROD,
    LIMPIAR_ERROR
} from "./productsAction";

/* 
    State encargado de la gestión de productos.
*/
const ProductsState = props => {

    const server = useContext(SocketContext);

    //Valores iniciales
    const initialState = {
        products: [],
        atributos: [],
        cargando: false,
        error: ""
    };

    const [state, dispatch] = useReducer(productsReducer, initialState);

    useEffect(() => {
        if (server) {
            server.on("modAbmProduct", ({ abmProducts }) => {
                dispatch({ type: ACTUALIZAR_PRODUCTOS_SOCKET, payload: abmProducts });
            });
            //Se dispara cuando el backend resincroniza los atributos de producto (tipo/grupo/subgrupo/marca)
            //contra Softland, para que la vista de Productos refleje los cambios sin recargar la página.
            server.on("modAbmAtributoProduct", ({ abmAtributoProducts }) => {
                dispatch({ type: ACTUALIZAR_ATRIBUTOS, payload: abmAtributoProducts });
            });
            return () => {
                server.off("modAbmProduct");
                server.off("modAbmAtributoProduct");
            };
        }
    }, [server]);

    /* 
        Función recuperar los productos y a su vez actualizarlos.
    */
    const actualizarProducts = async () => {

        try{

            const resp = await getAbmProduct();

            dispatch({
                type: ACTUALIZAR_PRODUCTOS,
                payload: resp.data.data
            })

            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    /* 
        Función encargada de sobreescribir la base de datos de productos con la propia de Softland.
            Donde userID es el ID del usuario en sesión.
                  userName es el nombre del usuario en sesión.
    */
    const actualizarProductsDB = async () => {

        try{
            console.log("ENTRO AL ACTUALIZAR PRODUCTOS");
            // El endpoint solo confirma que el proceso arrancó en segundo plano;
            // hay que esperar el aviso por socket para saber el resultado real.
            await uploadAbmProduct();

            if (!server) {
                throw new Error("No hay conexión en tiempo real disponible. Recargue la página e intente nuevamente.");
            }

            const resultado = await new Promise((resolve) => {
                server.once("actualizarAbmProductFinalizado", resolve);
            });

            if (resultado.status !== 200) {
                dispatch({
                    type: ERROR_PROD,
                    payload: resultado.message
                });
                return {status: false, msg: resultado.message};
            }

            const resp = await getAbmProduct();
            console.log(resp);
            dispatch({
                type: ACTUALIZAR_PRODUCTOS_DB,
                payload: resp.data.data
            });

        return {status: true, msg: "Se actualizo con exito la base de datos."};

        }catch(error){
            console.log(error);
            const errMsg = error.response?.data?.errMsg || error.response?.data?.message || error.message || 'Error desconocido';
            dispatch({
                type: ERROR_PROD,
                payload: errMsg
            });

            return {status: false, msg: errMsg};
        }
    }

    /*
        Función para recuperar los atributos de productos (tipo, grupo, subgrupo, marca) y actualizarlos.
    */
    const actualizarAtributos = async () => {

        try{
            const resp = await getAbmAtributoProducto();

            dispatch({
                type: ACTUALIZAR_ATRIBUTOS,
                payload: resp.data.data
            });

            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    const actualizarProductDBIndividual = async (tipPro, artCod) => {
        try {
            await uploadAbmProductIndividual(tipPro, artCod);
            // El estado se actualiza vía socket (modAbmProduct)
            return { status: true };
        } catch (error) {
            console.log(error);
            return { status: false, msg: error.response?.data?.message || error.message };
        }
    };

    const cargando =  () => {
        dispatch({
            type: CARGANDO_PROD
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    return(
        <productsContext.Provider
            value={{
                products: state.products,
                atributos: state.atributos,
                isCargando: state.cargando,
                error: state.error,
                actualizarProducts,
                actualizarProductsDB,
                actualizarProductDBIndividual,
                actualizarAtributos,
                cargando,
                limpiarError
            }}
        >

            {props.children}

        </productsContext.Provider>
    )
    
}

export default ProductsState;